import {
  useState
} from "react";

import toast from "react-hot-toast";

import {
  useNavigate
} from "react-router-dom";

import API from "../../services/api";

function AddBusiness() {

  const navigate =
    useNavigate();

  const [preview,
    setPreview] =
    useState("");

  const [logo,
    setLogo] =
    useState(null);

  const [form,
    setForm] =
    useState({
      business_name: "",
      owner_name: "",
      phone: "",
      email: "",
      password: "",
      gst_no: "",
      pan_no: "",
      address: "",
      status: 1
    });

const submit = async (e) => {
  e.preventDefault();

  try {
    const data = new FormData();

    Object.keys(form).forEach((key) => {
      data.append(key, form[key]);
    });

    if (logo) {
      data.append("logo", logo);
    }

    const res = await API.post(
      "/businesses",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success(
      res.data.message || "Business added successfully."
    );

    navigate("/admin/businesses");

  } catch (err) {
    console.log(err);

    toast.error(
      err.response?.data?.message || "Something went wrong."
    );
  }
};

  return (

    <div>

      <h1
        className="
        text-4xl
        font-bold
        mb-6
        "
      >
        Add Business
      </h1>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        rounded-2xl
        p-6
        "
      >

        <div
          className="
          grid
          md:grid-cols-2
          gap-5
          "
        >

          <div>

            <label className="block mb-2">
              Business Name
            </label>

            <input
              required
              value={
                form.business_name
              }
              onChange={(e) =>
                setForm({
                  ...form,
                  business_name:
                    e.target.value
                })
              }
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

          <div>

            <label className="block mb-2">
              Owner Name
            </label>

            <input
              required
              value={
                form.owner_name
              }
              onChange={(e) =>
                setForm({
                  ...form,
                  owner_name:
                    e.target.value
                })
              }
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

          <div>

            <label className="block mb-2">
              Phone
            </label>

            <input
              required
              value={
                form.phone
              }
              onChange={(e) =>
                setForm({
                  ...form,
                  phone:
                    e.target.value
                })
              }
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

          <div>

            <label className="block mb-2">
              Email
            </label>

            <input
              type="email"
              value={
                form.email
              }
              onChange={(e) =>
                setForm({
                  ...form,
                  email:
                    e.target.value
                })
              }
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

          <div>
            <label className="block mb-2">
              Admin Password
            </label>

            <input
              type="password"
              required
              value={form.password}
              onChange={(e) =>
                setForm({
                  ...form,
                  password: e.target.value
                })
              }
              className="
      w-full
      p-3
      rounded-xl
      bg-black
      border
      border-yellow-500/20
    "
            />
          </div>

          <div>

            <label className="block mb-2">
              GST Number
            </label>

            <input
              value={
                form.gst_no
              }
              onChange={(e) =>
                setForm({
                  ...form,
                  gst_no:
                    e.target.value
                })
              }
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

          <div>

            <label className="block mb-2">
              PAN Number
            </label>

            <input
              value={
                form.pan_no
              }
              onChange={(e) =>
                setForm({
                  ...form,
                  pan_no:
                    e.target.value
                })
              }
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

          <div>

            <label className="block mb-2">
              Status
            </label>

            <select
              value={
                form.status
              }
              onChange={(e) =>
                setForm({
                  ...form,
                  status:
                    e.target.value
                })
              }
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            >

              <option value={1}>
                Active
              </option>

              <option value={0}>
                Inactive
              </option>

            </select>

          </div>

          <div>

            <label className="block mb-2">
              Business Logo
            </label>

            <input
              type="file"
              accept="image/*"
              onChange={(e) => {

                setLogo(
                  e.target.files[0]
                );

                setPreview(
                  URL.createObjectURL(
                    e.target.files[0]
                  )
                );

              }}
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

        </div>

        <div className="mt-5">

          <label className="block mb-2">
            Address
          </label>

          <textarea
            rows="5"
            value={
              form.address
            }
            onChange={(e) =>
              setForm({
                ...form,
                address:
                  e.target.value
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />

        </div>

        {preview && (

          <div className="mt-5">

            <img
              src={preview}
              alt=""
              className="
              w-40
              h-40
              rounded-xl
              object-cover
              border
              border-yellow-500/20
              "
            />

          </div>

        )}

        <div
          className="
          flex
          gap-3
          mt-8
          "
        >

          <button
            type="submit"
            className="
            bg-yellow-500
            text-black
            px-6
            py-3
            rounded-xl
            font-semibold
            "
          >
            Save Business
          </button>

          <button
            type="button"
            onClick={() =>
              navigate(
                "/admin/businesses"
              )
            }
            className="
            bg-gray-700
            px-6
            py-3
            rounded-xl
            "
          >
            Cancel
          </button>

        </div>

      </form>

    </div>

  );

}

export default AddBusiness;